import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
var Link = /*#__PURE__*/function (_React$Component) {
  function Link() {
    _classCallCheck(this, Link);
    return _callSuper(this, Link, arguments);
  }
  _inherits(Link, _React$Component);
  return _createClass(Link, [{
    key: "isInternal",
    value: function isInternal(to) {
      return to.indexOf('://') === -1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var link;
      var to = this.props.to;
      var urlPathname;
      if (typeof to === 'string') {
        urlPathname = to;
      } else {
        urlPathname = to && to.pathname || '';
      }
      if (this.isInternal(urlPathname)) {
        link = /*#__PURE__*/React.createElement(NavLink, {
          to: to,
          className: function className(_ref) {
            var isActive = _ref.isActive;
            return classNames(_this.props.className, _defineProperty({}, _this.props.activeClassName, isActive));
          },
          onClick: this.props.onClick,
          rel: this.props.rel,
          style: this.props.style,
          "data-aut-id": this.props['data-aut-id'],
          title: this.props.title
        }, this.props.children);
      } else {
        link = /*#__PURE__*/React.createElement("a", {
          href: urlPathname,
          target: this.props.target,
          rel: "noopener noreferrer",
          className: this.props.className,
          onClick: this.props.onClick,
          "data-aut-id": this.props['data-aut-id'],
          style: this.props.style,
          title: this.props.title
        }, this.props.children);
      }
      return link;
    }
  }]);
}(React.Component);
Link.defaultProps = {
  activeClassName: '',
  className: '',
  onClick: function onClick() {},
  style: {},
  rel: '',
  target: '_blank',
  'data-aut-id': '',
  title: ''
};
export default Link;